enum PrimaryKeys {
    userStatus = 'user_status',
    pushIntegration = 'push_integration',
}

const QueryKeys = {
    userStatus: [PrimaryKeys.userStatus],
    pushIntegrations: [PrimaryKeys.pushIntegration],
};

export default QueryKeys;
